import { useNavigate } from "react-router-dom";
import { Search, Menu } from "lucide-react";
import { Input } from "@/components/ui/input";
import { TID } from "@/constants/testIds";
import { useState } from "react";
import { NotificationBell } from "./NotificationBell";
import { useAuth } from "@/context/AuthContext";
import { useSidebar } from "@/context/SidebarContext";

export function TopBar({ title, subtitle, actions }) {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const { isImpersonating } = useAuth();
  const { setOpen } = useSidebar();

  const submit = (e) => {
    e.preventDefault();
    const query = q.trim();
    if (!query) return;
    navigate(`/search?q=${encodeURIComponent(query)}`);
  };

  const stickyTop = isImpersonating ? "top-11" : "top-0";

  return (
    <header className={`h-16 border-b border-slate-200 bg-white/95 backdrop-blur sticky ${stickyTop} z-30 lg:ml-64`}>
      <div className="h-full flex items-center gap-3 sm:gap-4 px-3 sm:px-6">
        {/* Mobile hamburger */}
        <button
          data-testid="topbar-menu-btn"
          className="lg:hidden p-2 -ml-1 rounded hover:bg-slate-100 text-slate-700"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
        >
          <Menu className="w-5 h-5" />
        </button>

        <div className="min-w-0 flex-1">
          <h1 className="font-display text-base sm:text-[19px] font-semibold text-slate-900 leading-tight truncate">
            {title}
          </h1>
          {subtitle && <p className="hidden sm:block text-xs text-slate-500 truncate">{subtitle}</p>}
        </div>

        <form onSubmit={submit} className="hidden md:block w-60 lg:w-80">
          <div className="relative">
            <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
            <Input
              data-testid={TID.topbarSearch}
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search invoices, assets, docs…"
              className="pl-9 h-9 text-sm bg-slate-50 border-slate-200 focus-visible:ring-gbe"
            />
            <span className="hidden lg:inline-flex absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-medium tracking-wider text-slate-400 border border-slate-200 rounded px-1.5 py-0.5">
              ↵
            </span>
          </div>
        </form>

        <NotificationBell />

        <div className="hidden sm:flex items-center gap-2 flex-wrap justify-end">
          {actions}
        </div>
      </div>
    </header>
  );
}
